/**
 * 模組頁面代碼 : 1340-UI-01
 * 頁面說明 : 帳號管理清單列表頁面
 * @module modules/account-management/components/AccountManagementPage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';

import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class AccountManagementPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            searchBuildingId: '',
            searchRoleId: '',
            searchUserName: '',
        };
        this.setSearchBuildingId = this.setSearchBuildingId.bind(this);
        this.setSearchRoleId = this.setSearchRoleId.bind(this);
        this.setSearchUserName = this.setSearchUserName.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareAccountManagementTable = this.prepareAccountManagementTable.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.onBatchHandle = this.onBatchHandle.bind(this);
    }

    setSearchBuildingId(searchBuildingId) {
        this.setState({ searchBuildingId: searchBuildingId });
    }

    setSearchRoleId(searchRoleId) {
        this.setState({ searchRoleId: searchRoleId });
    }

    setSearchUserName(searchUserName) {
        this.setState({ searchUserName: searchUserName });
    }

    prepareAccountManagementTable = () => {
        const { userList } = this.props;

        // 定義資料內容
        const dataSet = userList.map((user) => {
            return [
                user.account,
                user.userName,
                user.roleName,
                user.buildingName,
                user.positionName,
                user.memo,
                user.updateTime,
                user.flgStatus,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            {
                orderable: false,
                order: null,
                title: '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
                data: null,
                render: function (data, type, row, meta) {
                    let checkboxId = 'cks-user-' + meta.row;
                    return `<div class="form-check">
                                <input class="form-check-input item-cks-user" type="checkbox" value="" id="${checkboxId}" name="cks" />
                                <label class="form-check-label" for="${checkboxId}"></label>
                            </div>`;
                },
                width: '5%',
            },
            { title: '帳號', data: 0 },
            { title: '姓名', className: 'dt-center', data: 1 },
            { title: '角色', className: 'dt-center', data: 2 },
            { title: '管理大樓', className: 'dt-left', data: 3 },
            { title: '職位', className: 'dt-center', data: 4 },
            { title: '備註', className: 'dt-left', data: 5 },
            { title: '修改時間', className: 'dt-head-center', data: 6, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            {
                orderable: false,
                order: null,
                title: '啟用',
                data: 7,
                className: 'dt-center',
                render: (data, type, row, meta) => {
                    let enableId = 'eab-user-' + meta.row;
                    let isChecked = data === 'A' ? 'checked' : '';
                    let enableButton = this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.DELETE) ? '' : 'disabled';
                    return `<div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton}/>
                                 <label class="form-check-label" for="${enableId}"></label>
                            </div>`;
                },
            },
            {
                orderable: false,
                order: null,
                data: null,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let editId = 'edit-user-' + meta.row
                    let pswId = 'psw-user-' + meta.row
                    let deleId = 'dele-user-' + meta.row
                    let editButton = this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="#ico-edit"></use>
                            </svg>
                            修改
                        </button>
                        <button type="button" class="btn btn-sm btn-link" id="${pswId}">
                            修改密碼
                        </button>` : '';
                    let deleteButton = this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.DELETE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${deleId}">
                            刪除
                        </button>` : '';
                    return `<div class="btn-group" role="group" aria-label="">
                                ${editButton}
                                ${deleteButton}
                            </div>`;
                },
            },
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 1,
            dir: 'asc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__userList')) {
            $('#datatable__userList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__userList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
        this.addEventListeners();
        batchCheckControls();
    }

    componentDidMount() {
        // 確認是否有帳號管理讀取權限
        this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.READ);
    }

    componentDidUpdate(prevProps) {
        const { needAccountManagementLoad, setNeedAccountManagementLoad, userList } = this.props;

        if (needAccountManagementLoad && 
            needAccountManagementLoad !== prevProps.needAccountManagementLoad) {
            if (userList.length > 0) {
                this.prepareAccountManagementTable();
            }
            setNeedAccountManagementLoad(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const buildingId = parseInt(searchForm.get('searchBuildingSelection')? searchForm.get('searchBuildingSelection') : 0);
        const userName =searchForm.get('searchUserName');
        const roleId = parseInt(searchForm.get('searchRoleSelection')? searchForm.get('searchRoleSelection') : 0);
        this.props.setSearchUser(buildingId, userName, roleId);
        this.props.fetchUserList(buildingId, userName, roleId).then(() => {
            // Get data and redraw datatable
            this.prepareAccountManagementTable();
        });
    }

    addEventListeners() {
        if (this.tableRef.current) {
            this.tableRef.current.addEventListener('click', (event) => {
                const button = event.target.closest('.btn');
                if (button && button.id.startsWith('edit-user-')) {
                    this.props.onEditUser(parseInt(button.id.split('-')[2]));
                }
                if (button && button.id.startsWith('psw-user-')) {
                    this.props.onEditPassword(parseInt(button.id.split('-')[2]));
                }
                if (button && button.id.startsWith('dele-user-')) {
                    const delUuser = this.props.userList[parseInt(button.id.split('-')[2])];
                    const userId = delUuser.userId;
                    const account = delUuser.account;
                    const userName = delUuser.userName;
                    const message = `[ ${account} (${userName}) ] 的帳號`;
                    this.props.onDeleteUser(message, userId);
                }
            });
            this.tableRef.current.addEventListener('change', (event) => {
                const checkbox = event.target.closest('input[type="checkbox"]');
                if (checkbox && checkbox.id.startsWith('eab-user-')) {
                    const index = parseInt(checkbox.id.split('-')[2]);
                    const mode = checkbox.checked ? AlertModalModeEnums.ENABLE : AlertModalModeEnums.DISABLE;
                    const updateUser = this.props.userList[index];
                    if (updateUser) {
                        let message = '';
                        if (mode === AlertModalModeEnums.ENABLE) {
                            message = `啟用 [ ${updateUser.account} (${updateUser.userName}) ] 的帳號`;
                        } else {
                            message = `停用 [ ${updateUser.account} (${updateUser.userName}) ] 的帳號`;
                        }
                        this.props.onEditUserStatus(mode, message, updateUser.userId);
                    } else {
                        console.log('No user found at index:', index);
                    }
                }
            });
        }
    }

    onBatchHandle(alertMode = AlertModalModeEnums.ENABLE) {
        const userIds = [];
        const checkboxes = document.querySelectorAll('.item-cks-user');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const userId = this.props.userList[parseInt(checkbox.id.split('-')[2])].userId;
                userIds.push(userId);
            }
        });
        // 如果沒有選擇任何資料就不處理
        if (userIds.length === 0) {
            return;
        }

        this.props.onBatchHandle(alertMode, userIds);      
    }

    render() {
        const { buildingSelection, roleSelection, onNewUser, onPositionList } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="系統設定" pageName="帳號管理" />
                <h4>帳號管理</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchBuildingSelection" className="form-label">管理大樓*</label>
                            <select className="form-select form-select-sm" id="searchBuildingSelection" name="searchBuildingSelection" value={this.state.searchBuildingId} onChange={e => this.setSearchBuildingId(e.target.value)} required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {buildingSelection.map((building, index) => (
                                    <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchUserName" className="form-label">姓名</label>
                            <input type="text" className="form-control form-control-sm" id="searchUserName" name="searchUserName" value={this.state.searchUserName} onChange={e => this.setSearchUserName(e.target.value)} />
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchRoleSelection" className="form-label">角色</label>
                            <select className="form-select form-select-sm" id="searchRoleSelection" name="searchRoleSelection"  value={this.state.searchRoleId} onChange={e => this.setSearchRoleId(e.target.value)} required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option> 
                                {roleSelection.map((role, index) => (
                                    <option key={index} value={role.roleId}>{role.roleName}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <button className="btn btn-primary" type="submit" aria-label="搜尋">
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__tool">
                    <div className="d-flex align-items-center gap-2">
                        <div className="datatable__tool__label">
                            多筆選擇
                            <div id="checked-count-display"></div>
                        </div>
                        <div className="btn-group btn-group-sm" role="group" aria-label="">
                            {this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="啟用" id="btnBatchEnable" onClick={() => this.onBatchHandle(AlertModalModeEnums.ENABLE)}>啟用</button>
                            )}
                            {this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="停用" id="btnBatchDisable" onClick={() => this.onBatchHandle(AlertModalModeEnums.DISABLE)}>停用</button>
                            )}
                            {this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.DELETE) && (
                            <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="刪除" id="btnBatchDelete" onClick={() => this.onBatchHandle(AlertModalModeEnums.DELETE)}>
                                <svg className="btn__icon me-2" aria-hidden="true">
                                    <use href="#ico-trash"></use>
                                </svg>
                                刪除
                            </button>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {this.checkPermission(ModuleEnums.POSITION, AccessModeEnums.READ) && (
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            aria-label="職位資訊"
                            id="modalPositionListBtn"
                            onClick={onPositionList}
                        >
                            <svg className="btn__icon me-2" aria-hidden="true">
                                <use href="#ico-certificate"></use>
                            </svg>
                            職位資訊
                        </button>
                        )}
                        {this.checkPermission(ModuleEnums.ACCOUNT_MANAGEMENT, AccessModeEnums.CREATE) && (
                        <button type="button" className="btn btn-sm btn-primary" aria-label="新增" id="modalAccountBtnNew" onClick={onNewUser}>
                            <svg className="btn__icon me-2" aria-hidden="true">
                                <use href="#ico-plus"></use>
                            </svg>
                            新增
                        </button>
                        )}
                    </div>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__userList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

AccountManagementPage.propTypes = {
};

AccountManagementPage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountManagementPage);